import './App.css';
import LoginForm from './views/loginForm';
import InsertEmail from './views/InsertEmail';
import ChangeInitialPassword from './views/ChangeInitialPassword';
import ChangePasswordbyEmail from './views/ChangePasswordbyEmail';
import ChangePassword from './views/ChangePassword';
import InsertCode from './views/InsertCode';
import MFA from './views/MFA';
import ResetPassword from './views/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import { Route, Routes, HashRouter } from "react-router-dom";

function App() {
  return (
    <HashRouter>
      <Routes>
        {/* Login - Sin protección */}
        <Route exact path="/" element={<LoginForm/>} />
        
        {/* InsertEmail - Sin protección (parte del flujo de login) */}
        <Route exact path="/InserEmail" element={<InsertEmail/>} />
        
        {/* InsertCode - Sin protección (parte del flujo de login) */}
        <Route exact path="/InsertCode" element={<InsertCode/>} />
        
        {/* ResetPassword - Sin protección (parte del flujo de login) */}
        <Route exact path="/ResetPassword" element={<ResetPassword/>} />
        
        {/* MFA - Solo usuarios con estado "MFA" */}
        <Route 
          exact 
          path="/MFA" 
          element={<ProtectedRoute element={<MFA/>} allowedStatuses={['MFA']} />} 
        />
        
        {/* ChangeInitialPassword - Solo usuarios con estado "RE" */}
        <Route 
          exact 
          path="/ChangeInitialPassword" 
          element={<ProtectedRoute element={<ChangeInitialPassword/>} allowedStatuses={['RE']} />} 
        />
        
        {/* ChangePassword - Solo usuarios con estado "Si" */}
        <Route 
          exact 
          path="/ChangePassword" 
          element={<ProtectedRoute element={<ChangePassword/>} allowedStatuses={['Si']} />} 
        />
        
        {/* ChangePasswordbyEmail - Solo usuarios con estado "Si" */}
        <Route 
          exact 
          path="/ChangePasswordbyEmail" 
          element={<ProtectedRoute element={<ChangePasswordbyEmail/>} allowedStatuses={['Si']} />} 
        />
      </Routes>
    </HashRouter>
  );
}

export default App;
